
import type { DailyKeywordData } from '@empathybroker/tsclient-stats/dist/models/daily-keywords/daily-keyword-data'
import type { AreaChartConfig, AreaChartData, Params } from '@empathyco/insights'
import type { PropType } from 'vue'
import type { KeywordData } from '../../../models/views/keywords'
import { AreaChartComponent } from '@empathyco/insights'

import { defineComponent } from 'vue'

import { KpiEnum } from '../../../enums'

export default defineComponent({
  name: 'KeywordSuggestion',
  props: {
    data: {
      type: Object as PropType<KeywordData>,
      required: true,
    },
  },
  data() {
    return {
      baseClass: 'epb-keyword-suggestion',
      chart: undefined,
    }
  },
  computed: {
    chartParams(): Params<AreaChartConfig, AreaChartData> {
      return {
        config: {
          locale: this.$epb.locale,
          transitionsDurationInMillis: 0,
          areaOpacity: 1,
        },
        data: [
          {
            name: KpiEnum.QUERIES,
            values: this.data.dist.map((distDataItem: DailyKeywordData) => ({
              name: distDataItem.date.toString(),
              value: distDataItem.queryCount,
            })),
          },
        ],
      }
    },
  },
  watch: {
    chartParams: {
      handler(params: Params<AreaChartConfig, AreaChartData>): void {
        this.chart.update(params)
      },
      deep: true,
    },
  },
  created(): void {
    this.chart = new AreaChartComponent()
  },
  mounted(): void {
    this.chart.init(this.$refs.chart, this.chartParams)
  },
  beforeDestroy(): void {
    this.chart.destroy()
  },
})
